import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useLocalStorage } from '@vueuse/core'
import { useAuthStore } from './auth'

// Locks the session to a selected game (issue 410). Keyed by the Authentik
// sub so two accounts sharing a browser don't inherit each other's selection,
// and so a transient silentRenew failure (isAuthenticated flips false for a
// moment) never wipes it — the entry for that sub simply isn't looked up
// until the user is authenticated again.
export const useSessionStore = defineStore('session', () => {
  const selectedBySub = useLocalStorage('tw:selectedScenarioBySub', {})

  const sub = computed(() => useAuthStore().user?.profile?.sub ?? null)

  const selected = computed(() => (sub.value ? selectedBySub.value[sub.value] ?? null : null))
  const selectedId = computed(() => selected.value?.id ?? null)
  const selectedName = computed(() => selected.value?.name ?? null)

  function select(id, name) {
    if (!sub.value || !id) return
    const existing = selectedBySub.value[sub.value]
    selectedBySub.value = {
      ...selectedBySub.value,
      [sub.value]: { id, name: name ?? (existing?.id === id ? existing.name : null) }
    }
  }

  function setNameIfSelected(id, name) {
    if (selectedId.value === id) select(id, name)
  }

  function clear() {
    if (!sub.value) return
    const { [sub.value]: _removed, ...rest } = selectedBySub.value
    selectedBySub.value = rest
  }

  return { selected, selectedId, selectedName, select, setNameIfSelected, clear }
})
